import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: string | number | null | undefined, currency = 'EUR') {
  if (amount == null) return '—'
  const n = typeof amount === 'string' ? Number.parseFloat(amount) : amount
  if (Number.isNaN(n)) return '—'
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency }).format(n)
}

export function formatDate(d: string | Date | null | undefined, opts?: Intl.DateTimeFormatOptions) {
  if (!d) return '—'
  const date = typeof d === 'string' ? new Date(d) : d
  if (Number.isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat(
    'it-IT',
    opts ?? { day: '2-digit', month: 'short', year: 'numeric' },
  ).format(date)
}

export function formatRelative(d: string | Date | null | undefined) {
  if (!d) return '—'
  const date = typeof d === 'string' ? new Date(d) : d
  if (Number.isNaN(date.getTime())) return '—'
  const seconds = Math.round((date.getTime() - Date.now()) / 1000)
  const rtf = new Intl.RelativeTimeFormat('it-IT', { numeric: 'auto' })
  const absSec = Math.abs(seconds)
  if (absSec < 60) return rtf.format(Math.round(seconds), 'second')
  if (absSec < 3600) return rtf.format(Math.round(seconds / 60), 'minute')
  if (absSec < 86400) return rtf.format(Math.round(seconds / 3600), 'hour')
  if (absSec < 86400 * 30) return rtf.format(Math.round(seconds / 86400), 'day')
  return formatDate(date)
}

export function formatHours(hours: number | null | undefined) {
  if (hours == null) return '—'
  return `${hours.toLocaleString('it-IT', { maximumFractionDigits: 1 })} h`
}
